import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

/*
idPostulante
nombrePostulante
dniPostulante
fechaIngresoPostulante
fechaNacimientoPostulante
grupoFamiliarPostulante
empresaPostulante (dropdown menu)
activoPostulantePostulante
fechaCargaPostulante

*/